import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Card } from '@mui/material';
import NotFoundRecords from 'src/components/NotFoundRecords';
import {
  isLoadingSelector,
  successSelector
} from 'src/store/selectors/statusSelector';
import {
  loadAgingBalance,
  LOAD_AGING_BALANCE
} from 'src/store/actions/accountingActions';
import {
  selectAgingBalanceList,
  selectAgingBalanceListCount,
  selectAgingBalanceQueryOptions
} from 'src/store/selectors/accountingSelector';
import AgingBalanceTable from './AgingBalanceTable';

const AgingBalanceList = ({ showFolio }) => {
  const dispatch = useDispatch();
  const agingBalanceList = useSelector(selectAgingBalanceList);
  const count = useSelector(selectAgingBalanceListCount);
  const queryOpts = useSelector(selectAgingBalanceQueryOptions);
  const loading = useSelector(isLoadingSelector([LOAD_AGING_BALANCE.action]));
  const success = useSelector(successSelector([LOAD_AGING_BALANCE.action]));

  const handleChangePage = useCallback(
    (event, value) => {
      dispatch(loadAgingBalance({ ...queryOpts, page: value }));
    },
    [dispatch, queryOpts]
  );

  if (success && !loading && count === 0) {
    return (
      <Card>
        <NotFoundRecords
          title="NOT_FOUND_RECORDS_MESSAGE.AGING_BALANCE_TITLE"
          description="NOT_FOUND_RECORDS_MESSAGE.AGING_BALANCE_DESCRIPTION"
        />
      </Card>
    );
  }

  return (
    <AgingBalanceTable
      agingBalanceList={agingBalanceList}
      count={count}
      page={queryOpts.page}
      handleChangePage={handleChangePage}
      loading={loading}
      showFolio={showFolio}
    />
  );
};

AgingBalanceList.propTypes = {
  showFolio: PropTypes.bool
};

AgingBalanceList.defaultProps = {
  showFolio: false
};

export default AgingBalanceList;

